export type PersonSecondaryLineSource = {
  primaryFacility?: { id?: string | null; name?: string | null } | null;
  primarySection?: { name?: string | null } | null;
  facilityName?: string | null;
  sectionName?: string | null;
};

function trimName(value: string | null | undefined): string | undefined {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
}

function resolvedFacilityName(source: PersonSecondaryLineSource): string | undefined {
  return trimName(source.primaryFacility?.name) ?? trimName(source.facilityName);
}

function resolvedSectionName(source: PersonSecondaryLineSource): string | undefined {
  return trimName(source.primarySection?.name) ?? trimName(source.sectionName);
}

export function formatPersonSecondaryLine(source: PersonSecondaryLineSource): string | undefined {
  const facilityName = resolvedFacilityName(source);
  const sectionName = resolvedSectionName(source);
  const line = [facilityName, sectionName].filter(Boolean).join(" · ");
  return line || undefined;
}
